<!-- <nav class="navbar navbar-expand-lg navbar-dark static-top nav-custom">
  <div class="container">
    <a class="navbar-brand header-logo" routerLink="/onboarding">
        <img src="https://res.cloudinary.com/dzz4lppcu/image/upload/v1607238429/truventor/tru-logo.png">
    </a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
    <div class="collapse navbar-collapse" id="navbarResponsive">
      <ul class="navbar-nav ml-auto header-links">
        <li class="nav-item">
          <a class="nav-link" *ngIf="isLoggedIn()" routerLink="/profile">Profile</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" (click)="logout()" *ngIf="isLoggedIn()">Logout</a>
        </li>
      </ul>
    </div>
  </div>
</nav> -->
<div class="new-supplier">
    <div class="container-fluid top-nav">
        <div class="row">
            <div class="mt-2 col-md-7">
                <img class="pointer" src="assets/svg/Logotype-Inverted.svg" alt="">
            </div>
            <div class="logout mt-3 pr-5 col-md-5">
                <h6 class="pointer text-right pr-3">Welcome, {{supplier_name |titlecase}} :&nbsp;&nbsp; <span (click)="logout()" *ngIf="isLoggedIn()" class="pointer">LOGOUT</span> </h6>
            </div>
        </div>
    </div>
    <div class="body">
        <div class="head">
            <h6 class="text-center mb-3">Setup Manufacturing Partner Account</h6>
            <p class="text-center">Complete below step to setup your manufacturing partner account</p>
        </div>

    </div>
</div>


<router-outlet></router-outlet>